<template>
  <div>
    <el-dialog
      :title="this.isCreated ? '新增礼包配置' : '编辑礼包配置'"
      center
      :visible="true"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="701px"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        size="mini"
        style="margin-right: 50px"
      >
        <el-form-item label="阶段：" prop="stage">
          <el-input style="width: 120px" v-model="form.stage"></el-input>
        </el-form-item>
        <el-form-item label="消耗的道具：">
          <el-select v-model="form.condition" filterable placeholder="道具">
            <el-option
              v-for="(item, key) in attachments"
              :key="key"
              :label="item"
              :value="parseInt(key)"
            >
            </el-option>
          </el-select>
          x
          <el-input
            placeholder="数量"
            style="width: 120px"
            v-model="form.consume"
          ></el-input>
        </el-form-item>
        <el-form-item label="可购买次数：" prop="receiveTimes">
          <el-input style="width: 120px" v-model="form.receiveTimes"></el-input>
        </el-form-item>
        <el-form-item label="礼包描述：" prop="name">
          <el-card>
            <base-desc @updated="updatedDesc" v-model="form.name"></base-desc
          ></el-card>
        </el-form-item>
        <el-form-item label="奖励：">
          <base-item-selector
            @updated="updatedItemSelector"
            v-model="form.rewards"
          ></base-item-selector>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="this.onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const util = require("@/util");
import BaseItemSelector from "../../biz-components/BaseItemSelector";
import BaseDesc from "../../biz-components/BaseDesc";
// 本弹窗名称
const DialogName = "EditTaskActivityGiftDialog";
export default {
  data() {
    return {
      form: {
        stage: "",
        condition: "",
        consume: "",
        receiveTimes: "",
        name: {},
        rewards: [],
      },
      attachments: {},
      isCreated: false,
      itemSelectorResult: [],
    };
  },

  computed: {},

  async created() {
    let value = this.$dialogutil.getData(DialogName);
    if (value.entry != null) {
      this.form = value.entry;
    }
    this.isCreated = value.isCreated;

    this.attachments = await this.$bizutil.loadAttachments(false);
  },
  components: {
    BaseItemSelector,
    BaseDesc,
  },

  methods: {
    /**
     * 编辑线上活动
     * @param {*} entry
     */
    async submit() {
      if (this.isCreated) {
        await this.add();
      } else {
        await this.update();
      }
    },

    async add() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认新增（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();
        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "新增成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) {}
    },
    async update() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认修改（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();

        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) {}
    },

    save() {
      let stage = parseInt(this.form.stage);
      if (isNaN(stage) || stage <= 0 || stage.toString() != this.form.stage) {
        return { errMsg: "阶段必须是一个正整数" };
      }

      let condition = parseInt(this.form.condition);
      if (
        isNaN(condition) ||
        condition <= 0 ||
        condition.toString() != this.form.condition
      ) {
        return { errMsg: "未选择购买礼包需要的消耗的道具" };
      }
      let consume = parseInt(this.form.consume);
      if (
        isNaN(consume) ||
        consume < 0 ||
        consume.toString() != this.form.consume
      ) {
        return {
          errMsg: "未选择购买礼包需要的消耗的道具数量必须是一个非负整数",
        };
      }

      let receiveTimes = parseInt(this.form.receiveTimes);
      if (
        isNaN(receiveTimes) ||
        receiveTimes <= 0 ||
        receiveTimes.toString() != this.form.receiveTimes
      ) {
        return { errMsg: "礼包的可购买次数必须大于0" };
      }

      if (this.itemSelectorResult.errMsg) {
        return { errMsg: this.itemSelectorResult.errMsg };
      }

      let rewards = this.itemSelectorResult;
      if (rewards.length == 0) {
        return { errMsg: "商品最少配置一项" };
      }

      return {
        stage: stage,
        condition: condition,
        consume: consume,
        receiveTimes: receiveTimes,
        name: this.form.name,
        rewards: rewards,
      };
    },

    async updatedDesc(param) {
      this.form.name = param;
    },

    async updatedItemSelector(param) {
      this.itemSelectorResult = param;
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
    onCloseWhitParam(param) {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName, param);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

